import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormikProps } from 'formik';
import { SUBTYPE_DP, SUBTYPE_DP_DETAIL } from '../../../../../routes/paths';
import {
    asyncGetParam,
    asyncGetSubtypeDPHistorical,
    asyncPatchSubtypeDPParam,
    asyncPostSubtypeDPParam,
} from '../../../../../services/param.service';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';
import { Param, ParamHistorical } from '../../../../../shared/types/param';

export const useSubtypeDPForm = () => {
    const navigate = useNavigate();
    const { idSubtypeDP } = useParams();
    const [subtypeDP, setSubtypeDP] = useState<Param>();
    const [loading, setLoading] = useState(false);
    const [formikSubtypeDPData, setFormikSubtypeDPData] =
        useState<FormikProps<Param>>();
    const [showHistorical, setShowHistorical] = useState(false);
    const [subtypeDPHistorical, setSuptypeDPHistorical] =
        useState<ParamHistorical[]>();

    const isValidForm = formikSubtypeDPData?.isValid;

    const handleCleanAndBack = () => {
        formikSubtypeDPData?.resetForm();
        navigate(SUBTYPE_DP);
    };

    const handleSubmit = async () => {
        await formikSubtypeDPData?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: Param = formikSubtypeDPData?.values;

        let res: any | undefined = undefined;

        try {
            if (subtypeDP && subtypeDP.id)
                res = await asyncPatchSubtypeDPParam(subtypeDP.id, data);
            else res = await asyncPostSubtypeDPParam(data);
        } catch (error) {}
        if (res?.items) {
            const item = Array.isArray(res?.items) ? res?.items[0] : res?.items;
            ToastSwal.fire({
                text: `¡Felicidades! el subtipo DP se ${
                    subtypeDP && subtypeDP.id ? 'actualizo' : 'creó'
                } satisfactoriamente.`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${SUBTYPE_DP_DETAIL}/${item.id}`);
        } else {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo ${
                    subtypeDP && subtypeDP.id ? 'actualizar' : 'crear'
                } el subtipo DP. Por favor, asegúrate de ${
                    subtypeDP && subtypeDP.id
                        ? 'diligenciar los datos correctamente'
                        : 'que no exista previamente'
                } e intenta nuevamente más tarde.`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    useEffect(() => {
        if (Boolean(idSubtypeDP)) {
            setLoading(true);
            asyncGetParam(idSubtypeDP)
                .then((subtypeDP: any) => {
                    if (!subtypeDP || !subtypeDP.items) navigate(SUBTYPE_DP);
                    setSubtypeDP(subtypeDP?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idSubtypeDP]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetSubtypeDPHistorical(idSubtypeDP)
                .then((resp) => {
                    if (resp) setSuptypeDPHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        subtypeDP,
        loading,
        isValidForm,
        handleSubmit,
        handleCleanAndBack,
        setFormikSubtypeDPData,
        subtypeDPHistorical,
        showHistorical,
        setShowHistorical,
    };
};
